/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_StripeInputs */

const da_privacy_recipient_stripe = /** @type {(inputs: Privacy_Recipient_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe, som tager imod betaling og sender kvitteringer og fakturaer.`)
};

/** @type {(inputs: Privacy_Recipient_StripeInputs) => LocalizedString} */
const en_privacy_recipient_stripe = da_privacy_recipient_stripe;

/**

* @param {Privacy_Recipient_StripeInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_stripe = /** @type {((inputs?: Privacy_Recipient_StripeInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_StripeInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_stripe(inputs)
	return /** @type {LocalizedString} */ ("Stripe, som tager imod betaling og sender kvitteringer og fakturaer.")
});